<template>
  <main class="dn-margin-1" v-bind:style="{height: height + 'px'}">
    <div class="card dn-card" v-for="(item, index) in pj" :key="index" @click="addClass(index, item)">
      <div class="card-header dn-card-header" :key="index" :class="{active:index==current, inactive:index!=current}" style="border-radius:20px 20px 0 0;">
        {{item.pjname}}
      </div>
      <div class="card-body" :class="isDnCardBody2 ? 'dn-card-body-2' : 'dn-card-body'">
        <img :src=item.pjsrc class="card-img-top" >
      </div>
    </div>
  </main>
</template>

<script>
import { Loading } from 'element-ui'
export default {
  name: 'model2',
  data () {
    return {
      height: document.body.clientHeight - 100,
      width: document.body.clientWidth,
      toPage: this.$route.query.toPage,
      pj: '',
      current: 0,
      topageConfig: '',
      isDnCardBody2: false
    }
  },
  methods: {
    addClass (index, item) {
      this.current = index
      this.$parent.toPage = item.toPage

      // 记录是否共享
      if (item.toPage === 's3' || item.toPage === 'win3' || item.toPage === 'nix3' || item.toPage === 'dwm3') {
        if (item.id === '1') {
          this.$parent.is_share = 'share'
        } else {
          this.$parent.is_share = 'noshare'
        }
      }

      this.topageConfig = this.$global.filter(item2 => item2.page === item.toPage)[0]
      if (this.topageConfig === undefined) {
        this.$parent.pathModel = '/home'
      } else if (this.topageConfig.videoSrc !== '') {
        this.$parent.pathModel = '/model1'
      } else if (this.topageConfig.pj.length === 1) {
        this.$parent.pathModel = '/model3'
      } else {
        this.$parent.pathModel = '/model2'
      }

      if (item.toPage === 's4-4-0' || item.toPage === 'win4-4-0' || item.toPage === 'nix4-4-0' || item.toPage === 'dwm4-4-0') {
        this.openWXKF()
      } else {
      // 安装进水系统单独处理
        if (this.$parent.pagehistory.indexOf(',/s5') > 0) {
          if (item.toPage === 's6-1') {
            if (this.$parent.pagehistory.indexOf(',/s4-1-0') > 0) {
              this.$parent.toPage = 's6-1'
            } else if (this.$parent.pagehistory.indexOf(',/s4-2-0') > 0) {
              this.$parent.toPage = 's6-2'
            } else {
              this.$parent.toPage = 's6-3'
            }
          } else if (item.toPage === 's7-1') {
            if (this.$parent.pagehistory.indexOf(',/s4-1-0') > 0) {
              this.$parent.toPage = 's7-1'
            } else if (this.$parent.pagehistory.indexOf(',/s4-2-0') > 0) {
              this.$parent.toPage = 's7-2'
            } else {
              this.$parent.toPage = 's7-3'
            }
          }
        }

        if (this.$parent.pagehistory.indexOf(',/win5') > 0) {
          if (item.toPage === 'win6-1') {
            if (this.$parent.pagehistory.indexOf(',/win4-1-0') > 0) {
              this.$parent.toPage = 'win6-1'
            } else if (this.$parent.pagehistory.indexOf(',/win4-2-0') > 0) {
              this.$parent.toPage = 'win6-2'
            } else {
              this.$parent.toPage = 'win6-3'
            }
          } else if (item.toPage === 'win7-1') {
            if (this.$parent.pagehistory.indexOf(',/win4-1-0') > 0) {
              this.$parent.toPage = 'win7-1'
            } else if (this.$parent.pagehistory.indexOf(',/win4-2-0') > 0) {
              this.$parent.toPage = 'win7-2'
            } else {
              this.$parent.toPage = 'win7-3'
            }
          }
        }

         if (this.$parent.pagehistory.indexOf(',/nix5') > 0) {
          if (item.toPage === 'nix6-1') {
            if (this.$parent.pagehistory.indexOf(',/nix4-1-0') > 0) {
              this.$parent.toPage = 'nix6-1'
            } else if (this.$parent.pagehistory.indexOf(',/nix4-2-0') > 0) {
              this.$parent.toPage = 'nix6-2'
            } else {
              this.$parent.toPage = 'nix6-3'
            }
          } else if (item.toPage === 'nix7-1') {
            if (this.$parent.pagehistory.indexOf(',/nix4-1-0') > 0) {
              this.$parent.toPage = 'nix7-1'
            } else if (this.$parent.pagehistory.indexOf(',/nix4-2-0') > 0) {
              this.$parent.toPage = 'nix7-2'
            } else {
              this.$parent.toPage = 'nix7-3'
            }
          }
        }
      }
    },
    // 客服链接
    openWXKF: async function () {
      let loading = Loading.service({
        lock: true,
        text: '正在跳转在线客服...',
        background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
        spinner: 'el-icon-loading',
        target: 'html',
        fullscreen: true
      })

      await setTimeout(function () {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc91b31322b344fa2f'
        loading.close()
      }, 3000)
    }
  },
  watch: {
    height (val) {
      this.height = val
    },
    width (val) {
      this.width = val
    },
    toPage: {
      handler: function (newValue, oldValue) {
        if (newValue === 'dwm2') {
          this.isDnCardBody2 = true
        } else {
          this.isDnCardBody2 = false
        }
        if (newValue !== undefined) {
          this.pj = this.$global.filter(item => item.page === newValue)[0].pj
        }
      },
      immediate: true
    },
    $route (to, from) {
      this.toPage = to.query.toPage
      this.current = 0
    }
  }
}
</script>
<style scoped>

.active {
    background-color: #ffc8aa;
}

.inactive {
  background-color:black;
}

.dn-card {
  width: 22rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
   border-width: 0;
}

.dn-card-header {
  color:white;
  height:2.5rem;
  line-height:0rem;
  border-radius:20px 20px 0 0;
}

.dn-card-body {
  padding: 0 0 0 0;
  margin-top: -2.5rem;
}

.dn-card-body-2 {
  padding: 0 0 0 0;
  margin-top: 0rem;
}

.dn-card-body img{
  border-radius:0 0 20px 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/model2.vue